import React from "react";
import content from "../data/results/2025content.json";
import ResultsPage from "./ResultsPage";

const Results2025 = () => <ResultsPage content={content} />;

export default Results2025;
